/**
 * @param {HTMLImageElement} image - Image File Object
 * @param {Object} crop - crop Object
 */
const getCroppedImg = (completedCrop, previewCanvasRef,imgRef)=> {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
        return;
      }
  
      const image = imgRef.current;
      const canvas = previewCanvasRef.current;
      const crop = completedCrop;
  
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      const ctx = canvas.getContext('2d');
      const pixelRatio = window.devicePixelRatio;
  
      canvas.width = crop.width * pixelRatio * scaleX;
      canvas.height = crop.height * pixelRatio * scaleY;
  
      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      ctx.imageSmoothingQuality = 'high';
  
      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width * scaleX,
        crop.height * scaleY
      );

      return canvas;
  
}

const getResizeb64Img = (cropImg, canvas, fileExtension) => {
 
  let resizedCanvas = document.createElement("canvas");
  let resizedContext = resizedCanvas.getContext("2d");
  resizedContext.imageSmoothingQuality = 'high';
  let min = 250, max = 400;  // min and max size SVS team allow

  let idealWidth = cropImg.width, idealHeight =cropImg.height;  // default size is user cropped size

  if(cropImg.width < min) { // if less than 250, set default to 250
    idealWidth = min;
  }
  else if(cropImg.width > max) {
    idealWidth = max;
  }
  else {
    idealWidth = cropImg.width;
  }

  if(cropImg.height < min) {
    idealHeight = min;
  }
  else if(cropImg.height > max) {
    idealHeight = max;
  }
  else {
    idealHeight = cropImg.height;
  }

  resizedCanvas.height = idealHeight;
  resizedCanvas.width = idealWidth;
  
  resizedContext.drawImage(canvas, 0, 0, idealWidth, idealHeight);

  const fileType = 'image/'+fileExtension;
 
  const base64Image = resizedCanvas.toDataURL(fileType, 1.0);

  return base64Image;
}

const getImgFileType = (extension) => {
 
  let fileType = 'image/png';
  if(extension.toLowerCase() === '.png' ) {
    fileType = 'image/png';
  }
  else if(extension.toLowerCase() === '.jpg') {
    fileType = 'image/jpg';
  }
  else if(extension.toLowerCase() === '.jpeg') {
    fileType = 'image/jpeg';
  }
  return fileType;
}



  export default {
    getCroppedImg,
    getResizeb64Img
  }
  